import React from "react";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import Modal from "../../modules/layout/Modal";
import { isQuestionAddModalOpenState } from "../../../recoil/admin/examRoom";
import AdminQuestionTable from "./AdminQuestionTable";
import AdminQuestionSelect from "./AdminQuestionSelect";
import {
  firstQuestionState,
  secondQuestionState,
  selectorState,
  thirdQuestionState,
} from "../../../recoil/admin/question";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useQuestionActions from "../../../api/hooks/admin/question";

const AdminQuestionAddModal = () => {
  const [isQuestionAddModalOpen, setIsQuestionAddModalOpen] = useRecoilState(
    isQuestionAddModalOpenState
  );

  const firstQuestion = useRecoilValue(firstQuestionState);
  const secondQuestion = useRecoilValue(secondQuestionState);
  const thirdQuestion = useRecoilValue(thirdQuestionState);

  const selectedValue = useRecoilValue(selectorState);

  const resetFirstQuestion = useResetRecoilState(firstQuestionState);
  const resetSecondQuestion = useResetRecoilState(secondQuestionState);
  const resetThirdQuestion = useResetRecoilState(thirdQuestionState);

  const resetSelectedValues = useResetRecoilState(selectorState);

  const { createCombo } = useQuestionActions();
  const queryClient = useQueryClient();

  const mutation = useMutation(createCombo, {
    onSuccess: (context) => {
      setIsQuestionAddModalOpen(false);
      resetFirstQuestion();
      resetSecondQuestion();
      resetThirdQuestion();
      resetSelectedValues();
      queryClient.invalidateQueries("fetchCombo");
    },
    onError: () => {
      alert("실패했습니다.");
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const req = {
      question: [firstQuestion, secondQuestion, thirdQuestion],
      combo: selectedValue,
    };

    mutation.mutate(req);
  };

  return (
    <>
      <Modal isOpen={isQuestionAddModalOpen}>
        <div className="modal fade" id="url" style={{ display: "block" }}>
          <div className="modal-content" style={{ width: "1540px" }}>
            <div className="modal-header flex">
              <div className="modal-title">
                <p>콤보</p>
              </div>
            </div>
            <div className="modal-body confirm-sec">
              <div className="modal-title">
                <p>콤보추가</p>
              </div>

              <form onSubmit={handleSubmit}>
                <AdminQuestionSelect />
                <AdminQuestionTable />
                <div className="modal-footer text-align-right">
                  <button
                    type="button"
                    className="modal-btn modal-close-btn"
                    onClick={() => {
                      setIsQuestionAddModalOpen(false);
                      resetFirstQuestion();
                      resetSecondQuestion();
                      resetThirdQuestion();
                      resetSelectedValues();
                    }}
                  >
                    닫기
                  </button>
                  <button type="submit" className="modal-btn modal-save-btn">
                    완료
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AdminQuestionAddModal;
